import React, { useState } from 'react';
import { Modal, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useHistory } from 'react-router-dom';

import Button from '../../../components/common/Button';
import ModalContent from '../../../components/common/Modal/ModalContent';
import Spinner from '../../../components/common/Spinner';
import workshopApi from '../workshop-api';
import { buildWorkshopPayload, getPillarId } from '../utils/workshopForm';

const summaryCopyByMode = {
  create: {
    action: 'Crear taller',
    confirm: '¿Estás seguro que deseas agregar un nuevo taller?',
    error: 'Error al crear el taller',
    modalTitle: 'Nuevo taller',
    success: 'Taller creado exitosamente',
  },
  edit: {
    action: 'Editar taller',
    confirm: '¿Estás seguro que deseas actualizar este taller?',
    error: 'Error al actualizar el taller',
    modalTitle: 'Editar taller',
    success: 'Taller actualizado exitosamente',
  },
};

const Alert = (props) => <MuiAlert elevation={6} variant="filled" {...props} />;

const WorkshopSummary = ({ workshopData, onPrev, mode = 'create', id }) => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const [isWorkshopSaved, setWorkshopSaved] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const copy = summaryCopyByMode[mode] || summaryCopyByMode.create;

  const handleCloseSnackbar = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleOpenModal = () => {
    if (!isWorkshopSaved && !isSubmitting) {
      setModalOpen(true);
    }
  };

  const handleCancel = () => {
    if (!isSubmitting) {
      setModalOpen(false);
    }
  };

  const saveWorkshop = async () => {
    try {
      setIsSubmitting(true);
      setSnackbar((prev) => ({ ...prev, open: false }));

      const payload = buildWorkshopPayload(workshopData);

      if (mode === 'edit') {
        await workshopApi.updateWorkshop(id || workshopData.id, payload);
      } else {
        await workshopApi.createWorkShop(payload);
      }

      setWorkshopSaved(true);
      history.push('/talleres', {
        snackbar: {
          severity: 'success',
          message: copy.success,
        },
      });
    } catch (error) {
      console.error(copy.error, error);
      setSnackbar({
        open: true,
        severity: 'error',
        message: copy.error,
      });
      setIsSubmitting(false);
    }
  };

  const handleConfirm = async () => {
    if (isSubmitting) {
      return;
    }
    setModalOpen(false);
    await saveWorkshop();
  };

  return (
    <>
      <div
        className="wizard__form wizard__form--full"
        style={{ position: 'relative' }}
      >
        {isSubmitting && (
          <Spinner
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              background: 'rgba(255, 255, 255, 0.65)',
              zIndex: 10,
              pointerEvents: 'all',
            }}
          />
        )}

        <div className="wizard__grid-section">
          <h2>Resumen</h2>
          <div
            className="container-summary"
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto',
              gridTemplateRows: 'auto',
              columnGap: '20px',
              rowGap: '20px',
            }}
          >
            <div style={{ gridColumn: '1' }}>
              <h3>Título</h3>
              <p>{workshopData.title ? workshopData.title : '-'}</p>
            </div>
            <div style={{ gridColumn: '1' }}>
              <h3>Descripción</h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: workshopData.description
                    ? workshopData.description
                    : '-',
                }}
              ></div>
            </div>
            <div style={{ gridColumn: '1' }}>
              <h3>Duración</h3>
              <div className="summaryInfo">
                <span
                  style={{ color: '#38bdf8' }}
                  className="material-symbols-outlined"
                >
                  timer
                </span>
                <p>
                  {workshopData.estimatedTime
                    ? workshopData.estimatedTime
                    : '-'}
                </p>
              </div>
            </div>
            <div style={{ gridColumn: '2', gridRow: '1' }}>
              <div>
                <h3>Pilar</h3>
                <div
                  style={{
                    borderRadius: '15px',
                    backgroundColor: '#f2f1f2',
                    width: 'fit-content',
                    padding: '7px 0 10px',
                    display: 'flex',
                  }}
                  key={getPillarId(workshopData.pillar) || 'empty-pillar'}
                >
                  <span
                    style={{
                      color: '#38bdf8',
                      paddingLeft: '5px',
                      paddingRight: '5px',
                    }}
                    className="material-symbols-outlined"
                  >
                    circle
                  </span>
                  {workshopData.pillar?.name || '-'}
                </div>
              </div>
            </div>
            <div
              style={{
                gridColumn: '2',
                gridRow: '2',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <h3>Link de YouTube</h3>
              <span style={{ color: '#38bdf8' }}>
                {workshopData.recordingLink ? workshopData.recordingLink : '-'}
              </span>
            </div>

            <Modal
              open={modalOpen}
              onClose={handleCancel}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  background: '#fff',
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                }}
              >
                <ModalContent title={copy.modalTitle} onClick={handleCancel}>
                  <button
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '24px',
                    }}
                    onClick={handleCancel}
                  />
                  <p>{copy.confirm}</p>
                  <div
                    style={{
                      marginTop: '20px',
                      display: 'flex',
                      justifyContent: 'center',
                      gap: '15px',
                    }}
                  >
                    <Button onClick={handleConfirm} loading={isSubmitting}>
                      Confirmar
                    </Button>
                    <Button
                      secondary
                      onClick={handleCancel}
                      disabled={isSubmitting}
                    >
                      Cancelar
                    </Button>
                  </div>
                </ModalContent>
              </div>
            </Modal>
          </div>
        </div>

        <div
          style={{ paddingTop: '30px', maxWidth: '500px', margin: 'auto' }}
          className="wizard__action"
        >
          <Button secondary onClick={onPrev}>
            Volver
          </Button>
          <Button
            type="button"
            onClick={handleOpenModal}
            disabled={isWorkshopSaved || isSubmitting}
            loading={isSubmitting}
          >
            {copy.action}
          </Button>
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default WorkshopSummary;
